// extracted by mini-css-extract-plugin
export var smallSpinner = "_wy-0";